// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"73a0eb0d","584":"bd1e9924"}[chunkId] + ".chunk.js";
};